import { redirect } from '@tanstack/react-router';

export const handleLegacyRedirect = (newPath) => {
  return () => {
    throw redirect({
      to: newPath,
      replace: true,
    });
  };
};
